// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "lead_contact_identity_reset".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "lead_contact_identity_reset" table (1:1 with a DB row, on the wire). */
export const leadContactIdentityResetAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    leadId: z.string(),
    channel: z.string(),
    resetAt: z.string().datetime(),
});
//# sourceMappingURL=leadContactIdentityReset.js.map